import { createFileRoute, Link, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { SquarePen } from "lucide-react";
import { useTranslations } from "use-intl";
import { requireRole } from "@/lib/auth/require-role";
import { PageHeader } from "@/components/ui/page-header";

export const Route = createFileRoute("/_admin/prompt-engine")({
  beforeLoad: async ({ location }) => {
    await requireRole("admin");
    if (location.pathname === "/prompt-engine" || location.pathname === "/prompt-engine/") {
      throw redirect({ to: "/prompt-engine/templates", replace: true });
    }
  },
  component: PromptEngineShell,
});

function PromptEngineShell() {
  const t = useTranslations();
  const router = useRouterState();
  const currentPath = router.location.pathname;

  const tabs = [
    { key: "templates", path: "/prompt-engine/templates", label: t("prompt_engine.tabs.templates") },
    { key: "use-cases", path: "/prompt-engine/use-cases", label: t("prompt_engine.tabs.use_cases") },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        icon={SquarePen}
        title={t("nav.prompt_engine")}
        description={t("prompt_engine.description")}
      >
        <nav
          role="tablist"
          aria-label={t("nav.prompt_engine")}
          className="-mx-2 flex items-end gap-0 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {tabs.map((tab) => {
            const isActive = currentPath.startsWith(tab.path);
            return (
              <Link
                key={tab.key}
                to={tab.path}
                role="tab"
                aria-current={isActive ? "page" : undefined}
                className={[
                  "relative shrink-0 min-h-[40px] rounded-t-lg px-4 py-2.5 text-sm font-medium transition-colors",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-1",
                  isActive
                    ? "text-[var(--foreground)] after:absolute after:bottom-0 after:left-2 after:right-2 after:h-0.5 after:bg-[var(--primary)]"
                    : "text-[var(--muted-foreground)] hover:bg-[var(--muted)]/55 hover:text-[var(--foreground)]",
                ].join(" ")}
              >
                {tab.label}
              </Link>
            );
          })}
        </nav>
      </PageHeader>

      <Outlet />
    </div>
  );
}
